var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M38.2729 20.8741C38.2729 11.4051 30.5967 3.72888 21.1277 3.72888C11.6586 3.72888 3.98242 11.4051 3.98242 20.8741C3.98242 29.4317 10.2522 36.5249 18.4487 37.8111V25.8302H14.0954V20.8741H18.4487V17.0968C18.4487 12.7998 21.0085 10.4262 24.9247 10.4262C26.8007 10.4262 28.7627 10.7611 28.7627 10.7611V14.9804H26.6007C24.471 14.9804 23.8066 16.3022 23.8066 17.6581V20.8741H28.5617L27.8016 25.8302H23.8066V37.8111C32.0032 36.5249 38.2729 29.432 38.2729 20.8741Z",
    fill: "#AAC7FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.3f1c60830409b66926a690bc4759cd6e.svg";
export { ForwardRef as ReactComponent };